// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module--container--rmphs","logo":"styles-module--logo--2-bca","sideLinks":"styles-module--sideLinks--33UjA"};